import { render, staticRenderFns } from "./AppSignUpHeader.vue?vue&type=template&id=0d214024"
import script from "./AppSignUpHeader.vue?vue&type=script&lang=js"
export * from "./AppSignUpHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports